import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "slotbooking-tabs status-tabs mb-5"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('状态')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "animated": false,
      "size": "small",
      "data-permission": "wrapper_list_status",
      "id": "wrapper_list_status"
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.searchData.status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "status", $$v);
      },
      expression: "searchData.status"
    }
  }, [_c('a-tab-pane', {
    key: undefined,
    attrs: {
      "tab": _vm.t('全部 {0}', [_vm.searchData.status === undefined ? _vm.total !== null ? "(" + _vm.total + ")" : '' : ''])
    }
  }), _vm._l(_vm.auditPageStatusEnum, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": _vm.searchData.status === item.value ? item.text + (_vm.total !== null ? "(" + _vm.total + ")" : '') : item.text
      }
    });
  })], 2)], 1), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "allow-clear": false,
      "data-permission": "wrapper_list_code_type",
      "id": "wrapper_list_code_type"
    },
    model: {
      value: _vm.searchData.package_option,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_option", $$v);
      },
      expression: "searchData.package_option"
    }
  }, _vm._l(_vm.packageOptionEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "allowClear": "",
      "maxLength": 100,
      "data-permission": "wrapper_list_code_value",
      "id": "wrapper_list_code_value"
    },
    model: {
      value: _vm.searchData.package_option_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_option_value", $$v);
      },
      expression: "searchData.package_option_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u5F52\u5C5E"),
      "show-tip": "",
      "placeholder": _vm.t('包材归属'),
      "data-permission": "wrapper_list_package_type",
      "id": "wrapper_list_package_type",
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.package_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_type", $$v);
      },
      expression: "searchData.package_type"
    }
  }, _vm._l(_vm.packageTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5305\u88C5\u7C7B\u578B"),
      "show-tip": "",
      "placeholder": _vm.t('包装类型'),
      "data-permission": "wrapper_list_package_category",
      "id": "wrapper_list_package_category",
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.package_category,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_category", $$v);
      },
      expression: "searchData.package_category"
    }
  }, _vm._l(_vm.packageCategoryEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u9002\u7528\u4ED3\u5E93\uFF08\u533A\u57DF\uFF09"),
      "show-tip": "",
      "placeholder": _vm.t('适用仓库（区域）'),
      "data-permission": "wrapper_list_warehouse_code",
      "id": "wrapper_list_warehouse_code",
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code
    }, [_vm._v(_vm._s(item.warehouse_name_text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u66F4\u65B0\u65F6\u95F4"),
      "allow-clear": false,
      "data-permission": "wrapper_list_time_type",
      "id": "wrapper_list_time_type",
      "placeholder": _vm.t('更新时间')
    },
    model: {
      value: _vm.searchData.time_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_type", $$v);
      },
      expression: "searchData.time_type"
    }
  }, _vm._l(_vm.packageTimeTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-range-picker', {
    attrs: {
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD",
      "data-permission": "wrapper_list_time_value",
      "id": "wrapper_list_time_value"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "wrapper_list_search",
      "data-permission": "wrapper_list_search",
      "id": "wrapper_list_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "wrapper_list_reset",
      "data-permission": "wrapper_list_reset",
      "id": "wrapper_list_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "ovh mb-15"
  }, [_c('span', {
    staticClass: "fl",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('div', {
    staticClass: "ml-20 fl"
  }, [_c('a-dropdown', [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "wrapper_export_all",
      "id": "wrapper_export_all",
      "data-sign": "wrapper_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "wrapper_export_select",
      "id": "wrapper_export_select",
      "data-sign": "wrapper_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1)], 1), _vm.isProductPrivateWrapper ? _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'wrapper_list_add',
      expression: "'wrapper_list_add'"
    }],
    staticClass: "fr",
    attrs: {
      "data-permission": "wrapper_list_add",
      "id": "wrapper_list_add",
      "data-sign": "wrapper_list_add",
      "type": "primary",
      "fbu-analyse-name": $t("\u65B0\u589E\u5305\u6750")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.t('新增包材')))]) : _vm._e()], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "name": "wrapperList",
      "columns": _vm.columns,
      "useMouseTool": "",
      "data-sign": "wrapper_list",
      "data-source": _vm.dataList,
      "fixed-header": "",
      "is-filter-box": "",
      "row-selection": _vm.rowSelection,
      "row-key": "package_code",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "size",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(_vm._f("filterSizeEmpty")(record, 'outer_box_length', 'outer_box_width', 'outer_box_height')) + " ")]);
      }
    }, {
      key: "status_text",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "width": "160px"
          }
        }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(record.status_text)) + " "), record.status === _vm.$enum.warehouse.WrapperStatus.REJECTED ? _c('a-tooltip', [_c('span', {
          attrs: {
            "slot": "title"
          },
          slot: "title"
        }, [_vm._v(_vm._s(_vm.t('驳回原因')) + _vm._s(_vm.tc('：')) + _vm._s(record.audit_remark))]), _c('a-icon', {
          style: {
            fontsize: '18px',
            color: '#FF7E00'
          },
          attrs: {
            "type": "exclamation-circle",
            "theme": "filled"
          }
        })], 1) : _vm._e()], 1);
      }
    }, {
      key: "warehouse",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record.new_warehouse_code_list && record.new_warehouse_code_list.length ? _c('div', [_vm._v(" " + _vm._s(record.new_warehouse_code_list.map(function (item) {
          return item.warehouse_code + '[' + item.warehouse_name + ']';
        }).join(',')) + " ")]) : _vm._e()]);
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', {
          staticClass: "colon-align"
        }, [_c('span', {
          staticClass: "colon-align-label"
        }, [_vm._v(_vm._s(_vm.t('创建')) + _vm._s(_vm.tc('：')))]), _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.create_time)))])]), _c('div', {
          staticClass: "colon-align"
        }, [_c('span', {
          staticClass: "colon-align-label"
        }, [_vm._v(_vm._s(_vm.t('更新')) + _vm._s(_vm.tc('：')))]), _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.update_time)))])])]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record.status === _vm.$enum.warehouse.WrapperStatus.REJECTED ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'wrapper_list_edit',
            expression: "'wrapper_list_edit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "wrapper_list_edit",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))]) : _vm._e(), record.status === _vm.$enum.warehouse.WrapperStatus.PASS && record.package_type === _vm.$enum.warehouse.WrapperPackageType.PRIVATE ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'wrapper_list_discard',
            expression: "'wrapper_list_discard'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "wrapper_list_discard",
            "fbu-analyse-name": $t("\u5E9F\u5F03")
          },
          on: {
            "click": function ($event) {
              return _vm.handleCancel(record.package_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('废弃')))]) : _vm._e(), _c('a', {
          staticClass: "mr-10",
          attrs: {
            "data-sign": "wrapper_list_log",
            "fbu-analyse-name": $t("\u65E5\u5FD7")
          },
          on: {
            "click": function ($event) {
              return _vm.handleLog(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('日志')))])]);
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "consumables_type_text"
    },
    slot: "consumables_type_text"
  }, [_vm._v(" " + _vm._s(_vm.t('包材')) + " ")])])], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "name": "wrapperList",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('add-edit-modal', {
    attrs: {
      "visible": _vm.addEditVisible,
      "rowData": _vm.rowData
    },
    on: {
      "update:visible": function ($event) {
        _vm.addEditVisible = $event;
      },
      "success": _vm.queryList
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };